module.exports = __webpack_public_path__ + "img/marker-orange.a1467e72.png";